import EdifyHelpers from "../helpers/EdifyHelpers";

export class CustomPostTypeService {
  /**
   * Inicializa o serviço
   */
  static init() {
    let typesFilter = [];
    const typesFilterCheckboxes = [
      ...$(".rich-content-filter .custom-control-input"),
    ];
    this.richContentFilter(typesFilter, typesFilterCheckboxes);
  }

  /**
   * Inicializa o filtro de posts
   * @param {string} typeList
   **/

  static richContentFilter(typesFilter, typesFilterCheckboxes) {
    const fetchPosts = this.fetchPosts.bind(this);

    typesFilterCheckboxes.forEach((checkbox) => {
      checkbox.addEventListener("change", function () {
        EdifyHelpers.disableCheckbox(typesFilterCheckboxes);
        const typeFilter = this.attributes
          .getNamedItem("data-type")
          .value.toLowerCase();

        if (this.checked) {
          typesFilter.push(typeFilter);
          fetchPosts(typesFilter);
          return;
        }
        typesFilter = typesFilter.filter((item) => item !== typeFilter);
        fetchPosts(typesFilter);
      });
    });
  }

  static fetchPosts(typesFilter) {
    const spinner = `<div class="d-flex justify-content-center align-items-center h-100">
                        <div class="spinner-border" role="status" aria-label="Aguarde... Carregando conteúdo"></div>
                      </div>`;
    const container = document.querySelector("#rich-content-filters");
    container.innerHTML = "";
    EdifyHelpers.showSpinnerContainer(container, spinner);
    const checkboxes = [...$(".rich-content-filter input[type='checkbox']")];

    const href = window.location.href;
    const locationURL = href.replace(/page.+/g, "");
    history.replaceState(null, null, locationURL);

    const url = `${locationURL}?${typesFilter
      .map((term) => `content-type[]=${term}`)
      .join("&")}`;

    fetch(url).then(async (response) => {
      EdifyHelpers.hideSpinnerContainer(container);
      const responseHTML = document.createElement("div");
      const textHTML = await response.text();
      responseHTML.innerHTML = textHTML;

      const filtersCards = responseHTML.querySelectorAll(
        "#rich-content-filters .cards"
      );
      const paginate = responseHTML.querySelector(".paginate");

      filtersCards.forEach((filterCard) => container.appendChild(filterCard));
      paginate && container.appendChild(paginate);
      EdifyHelpers.enableCheckbox(checkboxes);
    });
  }
}
